import * as React from 'react';
import AlignContext, { inertAlignContextProps } from "./AlignContext";

var AlignStatus = function AlignStatus(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(AlignContext.Consumer, null, function (context) {
    return children(context, context !== inertAlignContextProps);
  });
};

export default AlignStatus;